<template>
  <div>
    <!-- Clear Selected search criteria and Contacts,  Selected Search Criteria-->
    <vx-card class="mb-8">
      <div class="card-title more-card-title flex justify-between items-center">
        <div>
          <div class="flex items-center flex-wrap">
            <h2 class="w-auto mb-2"> {{ LabelConstant.headingLabelSelectedCriteria }} </h2>
            <p class="table-data-entries-details text-left mb-2"> {{ LabelConstant.buttonLabelTotalContacts }} :
              <span>{{ totalContacts | tableRecordNumberFormatter }}</span>
            </p>
          </div>
          <span class="text-success">{{ LabelConstant.buttonLabelDownloadLimit }} :
            <b>{{ totalContactLimitRemaining | tableRecordNumberFormatter}}</b>
          </span>
        </div>
        <!-- Clear Selected search criteria and Contacts -->
        <div class="flex items-center flex-wrap">
          <a :href="chromeExtensionLink" target="_blank" v-if="!this.$store.state.isReseller">
            <vs-button type="filled" class="bg-actionbutton mr-2">{{ LabelConstant.buttonLabelDownloadChromeExtension }}</vs-button>
          </a>
          <vs-button
            color="grey"
            type="border"
            class="grey-btn sm:mt-0 mt-2 ml-2"
            icon-pack="feather"
            icon="icon-refresh-ccw"
            @click="clearSearchCriteria()"
            >{{ LabelConstant.buttonLabelClearSearchCriteria }}
          </vs-button>
        </div>
      </div>
      <!-- Selected Search Criteria -->
      <div class="vx-row find-people">
        <div class="vx-col w-full">
          <input-tag v-model="tags" @input="testUpdateSelectedTags"></input-tag>
        </div>
      </div>
    </vx-card>

    <!-- Search Criteria Filter, Contacts Table -->
    <vx-card>
      <div class="vx-row find-people">
        <!-- Search Criteria Filter -->
        <div class="vx-col xl:w-1/4 col-cus-12 mb-8 w-full">
          <collapse-accordion
            ref="collapseAccordion"
            moduleName="SavedContact"
            class="search-filters"
            :jobTitleValue="jobTitleEntered"
            @jobTitleInput="
              (newJobTitle) => {
                jobTitleEntered = newJobTitle;
                termSeparation(jobTitleEntered,'jobTitle');
              }
            "
            jobLevelLabelName="Value"
            :jobLevelOptions="jobLevelOptions"
            :jobLevelValue="jobLevelSelected"
            @jobLevelInput="
              (newJobLevel) => {
                jobLevelSelected = newJobLevel;
              }
            "
            jobFunctionLabelName="Value"
            :jobFunctionOptions="jobFunctionOptions"
            :jobFunctionValue="jobFunctionSelected"
            @jobFunctionInput="
              (newJobFunction) => {
                jobFunctionSelected = newJobFunction;
              }
            "
            jobStartDateLabelName="Value"
            :jobStartDateOptions="jobStartDateOptions"
            :jobStartDateValue="jobStartDateSelected"
            @jobStartDateInput="
              (newJobStartDate) => {
                jobStartDateSelected = newJobStartDate;
              }
            "
            :recentChangedJobValue="recentChangedJob"
            @recentChangedJobInput="
              (newRecentChangedJob) => {
                recentChangedJob = newRecentChangedJob;
              }
            "
            :companyNameValue="companyNameEntered"
            @companyNameInput="
              (newCompanyName) => {
                companyNameEntered = newCompanyName;
                termSeparation(companyNameEntered,'companyName');
              }
            "
            :companyWebAddressValue="companyWebAddressEntered"
            @companyWebAddressInput="
              (newCompanyWebAddress) => {
                companyWebAddressEntered = newCompanyWebAddress;
                termSeparation(companyWebAddressEntered,'companyWebAddress');
              }
            "
            companyIndustryLabelName="Value"
            :companyIndustryOptions="companyIndustryOptions"
            :companyIndustryValue="companyIndustrySelected"
            @companyIndustryInput="
              (newCompanyIndustry) => {
                companyIndustrySelected = newCompanyIndustry;
              }
            "
            companyEmployeeSizeLabelName="Value"
            :companyEmployeeSizeOptions="companyEmployeeSizeOptions"
            :companyEmployeeSizeValue="companyEmployeeSizeSelected"
            @companyEmployeeSizeInput="
              (newCompanyEmployeeSize) => {
                companyEmployeeSizeSelected = newCompanyEmployeeSize;
              }
            "
            companyRevenueBandsLabelName="Value"
            :companyRevenueBandsOptions="companyRevenueBandsOptions"
            :companyRevenueBandsValue="companyRevenueBandsSelected"
            @companyRevenueBandsInput="
              (newCompanyRevenueBands) => {
                companyRevenueBandsSelected = newCompanyRevenueBands;
              }
            "
            companyNAICSLabelName="Value"
            :companyNAICSOptions="companyNAICSOptions"
            :companyNAICSValue="companyNAICSSelected"
            @companyNAICSInput="
              (newCompanyNAICS) => {
                companyNAICSSelected = newCompanyNAICS;
              }
            "
            companySICSLabelName="Value"
            :companySICSOptions="companySICSOptions"
            :companySICSValue="companySICSSelected"
            @companySICSInput="
              (newCompanyNAICS) => {
                companySICSSelected = newCompanyNAICS;
              }
            "
            :isRegion="false"
            contactRegionLabelName="Value"
            :contactRegionOptions="contactRegionOptions"
            :contactRegionValue="contactRegionSelected"
            @contactRegionInput="
              (newContactRegion) => {
                contactRegionSelected = newContactRegion;
              }
            "
            :isAddressType="true"
            addressTypeLabelName="Value"
            :addressTypeOptions="addressTypeOptions"
            :addressTypeValue="addressTypeSelected"
            @adddressTypeInput="
              (newAddressType) => {
                addressTypeSelected = newAddressType;
              }
            "
            contactCountriesLabelName="Value"
            :contactCountriesOptions="contactCountriesOptions"
            :contactCountriesValue="contactCountriesSelected"
            @contactCountriesInput="
              (newContactCountries) => {
                contactCountriesSelected = newContactCountries;
              }
            "
            contactStatesLabelName="Value"
            :contactStatesOptions="contactStatesOptions"
            :contactStatesValue="contactStatesSelected"
            @contactStatesInput="
              (newContactStates) => {
                contactStatesSelected = newContactStates;
              }
            "
            :contactCityValue="contactCityEntered"
            @contactCityInput="
              (newContactCity) => {
                contactCityEntered = newContactCity;
                termSeparation(contactCityEntered,'contactCity');
              }
            "
            :contactZipCodeValue="contactZipCodeEntered"
            @contactZipCodeInput="
              (newContactZipCode) => {
                contactZipCodeEntered = newContactZipCode;
                termSeparation(contactZipCodeEntered,'contactZipCode');
              }
            "
            :personalContactFirstNameValue="personalContactFirstNameEntered"
            @personalContactFirstNameInput="
              (newPersonalContactFirstName) => {
                personalContactFirstNameEntered = newPersonalContactFirstName;
              }
            "
            :personalContactLastNameValue="personalContactLastNameEntered"
            @personalContactLastNameInput="
              (newPersonalContactLastNameEntered) => {
                personalContactLastNameEntered =
                  newPersonalContactLastNameEntered;
              }
            "
            personalContactGenderLabelName="Value"
            :personalContactGenderOptions="personalContactGenderOptions"
            :personalContactGenderValue="personalContactGenderSelected"
            @personalContactGenderInput="
              (newPersonalContactGender) => {
                personalContactGenderSelected = newPersonalContactGender;
              }
            "
            :personalContactAlmaMaterValue="personalContactAlmaMaterEntered"
            @personalContactAlmaMaterInput="
              (newPersonalContactAlmaMater) => {
                personalContactAlmaMaterEntered = newPersonalContactAlmaMater;
                termSeparation(personalContactAlmaMaterEntered,'personalContactAlmaMater');
              }
            "
            :personalContactBirthdayFromValue="
              personalContactBirthdayFromEntered
            "
            @personalContactBirthdayFromInput="
              (newPersonalContactBirthdayFrom) => {
                personalContactBirthdayFromEntered =
                  newPersonalContactBirthdayFrom;
              }
            "
            :personalContactBirthdayToValue="personalContactBirthdayToEntered"
            @personalContactBirthdayToInput="
              (newPersonalContactBirthdayTo) => {
                personalContactBirthdayToEntered = newPersonalContactBirthdayTo;
              }
            "
            :personalContactSkillsValue="personalContactSkillsEntered"
            @personalContactSkillsInput="
              (newPersonalContactSkills) => {
                personalContactSkillsEntered = newPersonalContactSkills;
                termSeparation(personalContactSkillsEntered,'personalContactSkills');
              }
            "
            :personalContactFormerEmployerValue="personalContactFormerEmployerEntered"
            @personalContactFormerEmployerInput="
              (newPersonalContactFormerEmployer) => {
                personalContactFormerEmployerEntered = newPersonalContactFormerEmployer;
                termSeparation(personalContactFormerEmployerEntered,'personalContactFormerEmployer');
              }
            "
            :personalContactEmailAddressRequiredValue="
              personalContactEmailAddressRequired
            "
            @personalContactEmailAddressRequiredInput="
              (newPersonalContactEmailAddressRequired) => {
                personalContactEmailAddressRequired =
                  newPersonalContactEmailAddressRequired;
              }
            "
            :personalContactPhoneRequiredValue="personalContactPhoneRequired"
            @personalContactPhoneRequiredInput="
              (newPersonalContactPhoneRequired) => {
                personalContactPhoneRequired = newPersonalContactPhoneRequired;
              }
            "
            :suppressionCompanyWebAddressValue="suppressionCompanyWebAddressEntered"
            @suppressionCompanyWebAddressInput="
              (newSuppressionCompanyWebAddress) => {
                suppressionCompanyWebAddressEntered = newSuppressionCompanyWebAddress;
                termSeparation(suppressionCompanyWebAddressEntered,'suppressionCompanyWebAddress');
              }
            "
            :suppressionContactTitlesValue="suppressionContactTitlesEntered"
            @suppressionContactTitlesInput="
              (newSuppressionContactTitles) => {
                suppressionContactTitlesEntered = newSuppressionContactTitles;
                termSeparation(suppressionContactTitlesEntered,'suppressionContactTitles');
              }
            "
            :suppressionEmailAddressValue="suppressionEmailAddressEntered"
            @suppressionEmailAddressInput="
              (newSuppressionEmailAddress) => {
                suppressionEmailAddressEntered = newSuppressionEmailAddress;
                termSeparation(suppressionEmailAddressEntered,'suppressionEmailAddress');
              }
            "
            :suppressionExcludeMyLeadsValue="suppressionExcludeMyLeads"
            @suppressionExcludeMyLeadsInput="
              (newSuppressionExcludeMyLeads) => {
                suppressionExcludeMyLeads = newSuppressionExcludeMyLeads;
              }
            "
            :listPrimaryContactValue="listPrimaryContact"
            @listPrimaryContactInput="
              (newListPrimaryContact) => {
                listPrimaryContact = newListPrimaryContact;
              }
            "
            :listProfessionalEmailValue="listProfessionalEmail"
            @listProfessionalEmailInput="
              (newListProfessionalEmail) => {
                listProfessionalEmail = newListProfessionalEmail;
              }
            "
            :showListEmailConfidenceScoreValue="showListEmailConfidenceScore"
            @showListEmailConfidenceScoreInput="
              (newShowListEmailConfidenceScore) => {
                showListEmailConfidenceScore = newShowListEmailConfidenceScore;
              }
            "
            :listEmailConfidenceScoreValue="listEmailConfidenceScore"
            @listEmailConfidenceScoreInput="
              (newListEmailConfidenceScore) => {
                listEmailConfidenceScore = newListEmailConfidenceScore;
              }
            "
            :listDeterministicEmailValue="listDeterministicEmail"
            @listDeterministicEmailInput="
              (newListDeterministicEmail) => {
                listDeterministicEmail = newListDeterministicEmail;
              }
            "
            :listPhoneNumberValue="listPhoneNumber"
            @listPhoneNumberInput="
              (newListPhoneNumber) => {
                listPhoneNumber = newListPhoneNumber;
              }
            "
            :showRealTimeEmailScoreValue="showRealTimeEmailScore"
            @showRealTimeEmailScoreInput="
              (newShowRealTimeEmailScore) => {
                showRealTimeEmailScore = newShowRealTimeEmailScore;
              }
            "
            :realTimeEmailScoreValue="realTimeEmailScore"
            @realTimeEmailScoreInput="
              (newRealTimeEmailScore) => {
                realTimeEmailScore = newRealTimeEmailScore;
              }
            "
            userDefinedTagLabelName="TagName"
            :userDefinedTagsOptions="userDefinedTagsOptions"
            :userDefinedTagValue="userDefinedtagSelected"
            @userDefinedTagInput="
              (newUserDefinedTag) => {
                userDefinedtagSelected = newUserDefinedTag;
              }
            "
            savedFromLabelName="Value"
            :savedFromOptions="savedFromOptions"
            :savedFromValue="savedFromSelected"
            @savedFromInput="
              (newSavedFrom) => {
                savedFromSelected = newSavedFrom;
              }
            "
            savedByLabelName="Value"
            :savedByOptions="savedByOptions"
            :savedByValue="savedBySelected"
            @savedByInput="
              (newSavedBy) => {
                savedBySelected = newSavedBy;
              }
            "
            :savedDateValue="savedDateRange"
            @savedDateInput="
              (newSavedDate) => {
                savedDateRange = newSavedDate;
              }
            "
            :lastExportedValue="lastExportedRange"
            @lastExportedInput="
              (newlastExportedRange) => {
                lastExportedRange = newlastExportedRange;
              }
            "
            :excludeExportedValue="savedExcludeExported"
            @excludeExportedInput="
              (newSavedExcludeExported) => {
                savedExcludeExported = newSavedExcludeExported;
              }
            "
            @search-contacts="searchSavedContacts"
          ></collapse-accordion>
        </div>
        <!-- Record Per page, Export, Saved Contacts table (Contacts Table) -->
        <div class="vx-col xl:w-3/4 col-cus-12 mb-8 w-full border-left">
          <!-- Record Per page, Export -->
          <div>
            <vs-navbar class="nabarx mb-8 table-nav">
              <div slot="title">
                <vs-navbar-title>{{ LabelConstant.popupTitleLabelSavedContacts }}</vs-navbar-title>
              </div>

              <vs-navbar-item index="2">
                <dropdown-menu class="dropdown-export">
                  <button slot="trigger" class="dropdown-export-btn">
                    {{ LabelConstant.buttonLabelExport }}
                    <i class="vs-icon notranslate icon-scale material-icons null">expand_more</i>
                  </button>

                  <ul slot="body">
                    <li @click="savedExportType = 'csv', getContactLimits('csv')">
                      {{ LabelConstant.buttonLabelExportCSV }}
                    </li>
                    <li @click="savedExportType = 'excel', getContactLimits('excel')">
                      {{ LabelConstant.buttonLabelExportExcel }}
                    </li>
                    <!-- <li @click="CommingsoonPopup = true" v-if=" initialRole == 'Global Admin' && appRunningOnDev.toLowerCase() === 'true' ">
                      {{ LabelConstant.buttonLabelExportCRM }}
                    </li> -->
                    <li v-if="appRunningOnDev.toLowerCase() === 'true' && enableZapierIntegration" @click="checkHasZapierContactSetup()">Selected to Zapier</li>
                    <li @click="savedContactQueryResultToCSV()">
                      {{ LabelConstant.buttonLabelExportQueryResultToCSV }}
                    </li>
                  </ul>
                </dropdown-menu>
                <!-- <vs-dropdown>
                  <a class="a-icon" href="#">{{ LabelConstant.buttonLabelExport }}
                    <vs-icon class="" icon="expand_more"></vs-icon>
                  </a>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click=" (savedExportType = 'csv'), getContactLimits('csv') " > {{ LabelConstant.buttonLabelExportCSV }} </vs-dropdown-item>
                    <vs-dropdown-item @click=" (savedExportType = 'excel'), getContactLimits('excel') " > {{ LabelConstant.buttonLabelExportExcel }}</vs-dropdown-item>
                    <vs-dropdown-item @click="CommingsoonPopup = true" v-if=" initialRole == 'Global Admin' && appRunningOnDev.toLowerCase() === 'true' ">
                      {{ LabelConstant.buttonLabelExportCRM }}
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="savedContactQueryResultToCSV()" v-if=" initialRole == 'Global Admin' && appRunningOnDev.toLowerCase() === 'true' ">
                      {{ LabelConstant.buttonLabelExportQueryResultToCSV }}
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown> -->
              </vs-navbar-item>
              <vs-navbar-item index="3">
                 <dropdown-menu class="dropdown-export">
                  <button slot="trigger" class="dropdown-export-btn"> {{ LabelConstant.buttonLabelTag }}
                    <i class="vs-icon notranslate icon-scale material-icons null" >expand_more</i>
                  </button>

                  <ul slot="body">
                   <li @click="addTagToSeleted(), tagModuleRequest = 'add'">
                      {{ LabelConstant.labelAddTagtoSelected }}
                    </li>
                    <li @click="removeTagSelected(), tagModuleRequest = 'remove'">
                      {{ LabelConstant.labelRemoveTagfromSelected }}
                    </li>
                    <li @click="tagModuleRequest = 'add', listContactSavedTags(), manageTagsPopup = true">
                      {{ LabelConstant.labelManageTags }}
                    </li>
                  </ul>
                </dropdown-menu>
                <!-- <vs-dropdown>
                  <a class="a-icon" href.prevent>Tag
                    <vs-icon class="" icon="expand_more"></vs-icon>
                  </a>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="addTagToSeleted(), (tagModuleRequest = 'add')">
                      Add Tag to Selected
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="removeTagSelected(), (tagModuleRequest = 'remove')">
                      Remove Tag from Selected
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="tagModuleRequest = 'add', listContactSavedTags(), manageTagsPopup = true">
                      Manage Tags
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown> -->
              </vs-navbar-item>
              <v-select
                class="show-tbl-data"
                label="value"
                :options="showEntriesOptions"
                :reduce="(option) => option.value"
                :clearable="false"
                v-model="recordPerMainPage"
                @input="searchPaginationSetTimeOut()"
              />
            </vs-navbar>
          </div>
          <!-- <div class="card-title more-card-title d-flex">
            <div><h2>Saved Contacts</h2></div>
            <div>
              <v-select
                class="mr-2 float-left show-tbl-data"
                label="value"
                :options="showEntriesOptions"
                :reduce="(option) => option.value"
                :clearable="false"
                v-model="recordPerMainPage"
              />
              <vs-button
                title="Update"
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-download"
                class="mr-2 float-left"
                @click="openExportContactOptionsPopup = true"
                >{{ LabelConstant.buttonLabelExport }}</vs-button
              >
            </div>
          </div> -->
          <!-- Saved Contact table (Contacts Table) -->
          <div class="common-table pt-0" v-if="contacts && contacts.length > 0">
            <!-- Contacts table -->
            <vs-table multiple v-model="selectedMain" :data="contacts">
              <template slot="thead">
                <vs-th>{{ LabelConstant.tableHeaderLabelLogo }}</vs-th>
                <vs-th>{{ LabelConstant.tableHeaderLabelFullName }}</vs-th>
                <vs-th>{{ LabelConstant.tableHeaderLabelLinkedIn }}</vs-th>
                <vs-th>{{ LabelConstant.tableHeaderLabelTitle }}</vs-th>
                <vs-th>{{ dynamicLocationColumnName }}</vs-th>
                <vs-th>{{ LabelConstant.tableHeaderLabelCompany }}</vs-th>
                <vs-th>{{ LabelConstant.tableHeaderLabelSavedFrom }}</vs-th>
                <vs-th>{{ LabelConstant.tableHeaderLabelPhone }}</vs-th>
                <vs-th>{{ LabelConstant.tableHeaderLabelEmail }}</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].CompanyLogoUrl">
                    <a
                      v-if=" data[indextr].CompanyName != '' && data[indextr].CompanyId != 0"
                      @click=" companyDetailPopup = true, selectedCompanyId = data[indextr].CompanyId, getCompanyDetail(data[indextr].CompanyId)"
                    >
                      <img
                        :src="data[indextr].CompanyLogoUrl"
                        alt="Company Logo"
                        height="50"
                        width="50"
                      />
                    </a>
                    <img
                      v-else
                      :src="data[indextr].CompanyLogoUrl"
                      alt="Company Logo"
                      height="50"
                      width="50"
                    />
                  </vs-td>
                  <vs-td :data="data[indextr].fullName">
                    <div class="flex items-center">
                      <a @click="contactsDetailPopup = true, tagModuleRequest = 'update', selectedContactId = data[indextr].Id, getSavedContactDetail()">
                        {{ data[indextr].fullName }}
                      </a>
                    </div>
                  </vs-td>
                  <vs-td>
                    <a
                      v-show="data[indextr].ContactLinkedinUrl && data[indextr].ContactLinkedinUrl != ''"
                      :href="'https://' + data[indextr].ContactLinkedinUrl"
                      target="_blank"
                    >
                      <vs-avatar
                        color="primary"
                        icon-pack="feather"
                        icon="icon-linkedin"
                        size="28px"
                      />
                    </a>
                  </vs-td>
                  <vs-td :data="data[indextr].ContactTitle">
                    {{ data[indextr].ContactTitle }}
                  </vs-td>
                  <vs-td :data="data[indextr].location">
                    {{ data[indextr].location }}
                    <div class="flex who-to-contact-help-icon">
                      <vx-tooltip
                        title="HQ"
                        color="secondary"
                        :text="data[indextr].addressHq"
                        v-if="data[indextr].HasHqAddress"
                      >
                        <vs-button
                          type="flat"
                          icon-pack="material-icons"
                          icon="apartment"
                          class="p-0 help-btn"
                        ></vs-button>
                      </vx-tooltip>
                      <vx-tooltip
                        title="Local"
                        color="secondary"
                        :text="data[indextr].addressLocal"
                        v-if="data[indextr].HasLocalAddress"
                      >
                        <vs-button
                          type="flat"
                          icon-pack="material-icons"
                          icon="place"
                          class="p-0 help-btn"
                        ></vs-button>
                      </vx-tooltip>
                      <vx-tooltip
                        title="Physical"
                        color="secondary"
                        :text="data[indextr].addressPhysical"
                        v-if="data[indextr].HasPhysicalAddress"
                      >
                        <vs-button
                          type="flat"
                          icon-pack="material-icons"
                          icon="home_work"
                          class="p-0 help-btn"
                        ></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                  <vs-td :data="data[indextr].CompanyName">
                    <a
                      v-if="data[indextr].CompanyName != '' && data[indextr].CompanyId != 0"
                      @click="companyDetailPopup = true, selectedCompanyId = data[indextr].CompanyId, getCompanyDetail(data[indextr].CompanyId)"
                    >
                      {{ data[indextr].CompanyName }}
                    </a>
                  </vs-td>
                  <vs-td :data="data[indextr].IsSavedContact" class="saved-from">
                    <!-- <span v-show="data[indextr].IsSavedContact == true">Yes</span>
                    <span v-show="data[indextr].IsSavedContact == false">No</span> -->
                    <vx-tooltip text="Visual Visitor Plugin" v-if="data[indextr].SavedFrom == 'plugin'">
                      <img src="../../../src/assets/images/small-logo.png" class="d-inline-block saved-from-images" />
                    </vx-tooltip>
                    <vx-tooltip text="Who to Contact" v-if="data[indextr].SavedFrom == 'searchcontact'">
                      <img src="../../../src/assets/images/who-search.png" class="d-inline-block saved-from-images" />
                    </vx-tooltip>
                    <vx-tooltip text="Website Visitor" v-if="data[indextr].SavedFrom == 'visitor'">
                      <img src="../../../src/assets/images/profile.png" class="d-inline-block saved-from-images" />
                    </vx-tooltip>
                    <vx-tooltip text="Who's Shopping" v-if="data[indextr].SavedFrom == 'shopping'">
                      <img src="../../../src/assets/images/layers.png" class="d-inline-block saved-from-images" />
                    </vx-tooltip>
                    <vx-tooltip text="Data Enrichment" v-if="data[indextr].SavedFrom == 'enrichment'">
                      <img src="../../../src/assets/images/database.png" class="d-inline-block saved-from-images" />
                    </vx-tooltip>
                  </vs-td>
                  <vs-td>
                    <a @click="contactsDetailPopup = true, tagModuleRequest = 'update', selectedContactId = data[indextr].Id, getSavedContactDetail()">
                      <feather-icon
                        class="text-success"
                        icon="PhoneIcon"
                        v-show="data[indextr].HasDirectPhone"
                        title="Direct Phone"
                      ></feather-icon>
                      <feather-icon
                        class="text-warning"
                        icon="SmartphoneIcon"
                        v-show="data[indextr].HasMobilePhone"
                        title="Mobile Phone"
                      ></feather-icon>
                    </a>
                  </vs-td>
                  <vs-td>
                    <a @click="contactsDetailPopup = true, tagModuleRequest = 'update', selectedContactId = data[indextr].Id, getSavedContactDetail()">
                      <feather-icon
                        class="text-success"
                        icon="MailIcon"
                        v-show="data[indextr].HasCompanyEmail"
                        title="Company Email"
                      ></feather-icon>
                      <feather-icon
                        class="text-warning"
                        icon="MailIcon"
                        v-show="data[indextr].HasPersonalEmail"
                        title="Personal Email"
                      ></feather-icon>
                    </a>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <!-- Total contacts and Pagination -->
            <div class="vx-row clear-both">
              <div class="vx-col w-full lg:w-full mt-4">
                <div class="flex items-center justify-between paginate-row flex-wrap">
                  <p class="table-data-entries-details">{{ LabelConstant.buttonLabelTotalContacts }} :
                    <span>{{ totalContacts | tableRecordNumberFormatter }}</span>
                  </p>
                  <!-- <paginate
                    ref="contactsMainPaginate"
                    :page-count="totalPages"
                    :click-handler="searchContactsByPagination"
                    :prev-text="'<'"
                    :next-text="'>'"
                    :page-range="3"
                    :first-last-button="true"
                    :first-button-text="'|<'"
                    :last-button-text="'>|'"
                    :container-class="'paginate'"
                  >
                  </paginate> -->
                  <!-- <paginate
                    ref="contactsMainPaginate"
                    :page-count="1"
                    :click-handler="searchContactsByPagination"
                    :prevText="'< Prev'"
                    :nextText="'Next >'"
                    :page-range="1"
                    :first-last-button="false"
                    :container-class="'paginate'"
                  >
                  </paginate> -->
                  <b-pagination
                    ref="savedContactsMainPaginate"
                    pills
                    size="sm"
                    class="pr-3 bootstrap-pagination"
                    v-model="currentPage"
                    :total-rows="totalContacts"
                    :per-page="recordPerMainPage"
                    :limit="1"
                    prev-text="< Prev"
                    next-text="Next >"
                    :hide-goto-end-buttons="true"
                    @change="searchPaginationSetTimeOut()"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
          <!-- if no contacts found -->
          <div v-else>
            <div class="row pt-2 no-data-found">
              <div class="col-12 text-center">
                <div class="sm:w-1/4 w-1/2 mx-auto">
                  <img
                    src="../../../src/assets/images/no-data.png"
                    class="d-inline-block w-full"
                  />
                </div>
                <h2>Oops! No contacts found with your search.</h2>
              </div>
              <div class="col-12 text-center">
                <div class="lg:w-1/2 md:w-2/3 w-full mx-auto text-left pt-3">
                  <h6 class="py-2">Suggestions</h6>
                  <ul class="pl-5">
                    <li>Try a more generalized search criteria.</li>
                    <li>Make sure your names and terms are spelled correctly.</li>
                    <li>Try different criteria</li>
                    <!-- <li class="link" @click="searchTipsPopup = true">Try these search tips</li> -->
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- end if no contacts found -->
          <!-- Download Excel -->
          <div v-show="false">
            <xlsx-workbook>
              <xlsx-sheet
                :collection="downloadContact.data"
                v-for="downloadContact in downloadContacts"
                :key="downloadContact.name"
                :sheet-name="downloadContact.name"
              />
              <xlsx-download
                :filename="'Contacts.csv'"
                :options="{ bookType: 'csv' }"
              >
                <a ref="selectedToCsv">{{ LabelConstant.buttonLabelExportCSV }}</a>
              </xlsx-download>
            </xlsx-workbook>
          </div>
          <!-- Download Excel -->
          <div v-show="false">
            <xlsx-workbook>
              <xlsx-sheet
                :collection="downloadContact.data"
                v-for="downloadContact in downloadContacts"
                :key="downloadContact.name"
                :sheet-name="downloadContact.name"
              />
              <xlsx-download
                :filename="'Contacts.xlsx'"
                :options="{ bookType: 'xlsx' }"
              >
                <a ref="selectedToExcel">{{ LabelConstant.buttonLabelExportExcel }}</a>
              </xlsx-download>
            </xlsx-workbook>
          </div>
        </div>
      </div>
    </vx-card>

    <!-- Select Connection -->
    <find-any-one-select-connection
      :popupTitle="'Select Connection'"
      :connectionPopup="connectionPopup"
      :pushModule="pushModule"
      :selectedMain="selectedMain"
      :selectedInner="selectedMain"
      :applicationId="5"
      @cancelConnection="connectionPopup = false,selectedInner = [],selectedMain = [],pushModule = null"
    ></find-any-one-select-connection>

    <!-- search tips modal -->
    <find-any-one-search-tips-modal
      :popupTitle="'Search Tips'"
      :isPopup="searchTipsPopup"
      @searchTipsPopupIput="
        (newSearchTipsPopup) => {
          searchTipsPopup = newSearchTipsPopup;
        }
      "
    ></find-any-one-search-tips-modal>

    <!-- Export Contact options modal (after selecting contacts and clicking on Export button this will open) -->
    <find-any-one-export-options-modal
      :popupTitle="'Export Contacts'"
      :isPopup="openExportContactOptionsPopup"
      @openExportContactOptionsPopupInput="
        (newOpenExportContactOptionsPopup) => {
          openExportContactOptionsPopup = newOpenExportContactOptionsPopup;
        }
      "
      @exportContactTypeInput="
        (newExportContactType) => {
          exportContactType = newExportContactType;
        }
      "
      @clickForGetContactLimits="getContactLimits()"
      @contactpushTocrm="openExportContactOptionsPopup = false,connectionPopup = true,pushModule = 'contact'"
    ></find-any-one-export-options-modal>

    <!-- Download Excel contacts (After getting export contacts use can download CSV or EXCEL) -->
    <find-any-one-download-final
      :popupTitle="'Download Contacts'"
      :isPopup="downloadExcelContactPopup"
      :sheetOptions="downloadContacts"
      :excelFileName="'Contacts.xlsx'"
      :excelOptions="{ bookType: 'xlsx' }"
      :csvFileName="'Contacts.csv'"
      :csvOptions="{ bookType: 'csv' }"
      :whichOptionShow="exportContactType"
      @clickForFinish="downloadExcelContactPopup = false, exportContactType = null"
      @downloadPushTOCRM="downloadExcelContactPopup = false,connectionPopup = true,pushModule = 'contact'"
      :showPushtoCRM="true"
    ></find-any-one-download-final>

    <!-- Credit warning popup (If there are enough contact limit then this will open) -->
    <find-any-one-credit-warning-modal
      :popupTitle="'Contact Credits'"
      :isPopup="creditWarningPopup"
      :isShowCreditDeduction="isCreditDeductionEnable"
      :creditDeductionMessage="numberOfCreditMessage"
      :isCompanyDetailPopup="companyDetailPopup"
      :isSelectedMainLength="selectedMain.length > 0"
      :selectedContactId="selectedContactId"
      :exportContactType="exportContactType"
      :isSelectedInnerLength="selectedInner.length > 0"
      @getContactDetail="
        creditWarningPopup = false,
        numberOfCreditMessage = null,
        isCreditDeductionEnable = false,
        tagModuleRequest = 'contactdetails',
        addTagToContacts(
          tags = { contactSelectedTags: [], isExportContact: false }
        )
      "
      @exportContacts="!companyDetailPopup? exportContacts(selectedMain): exportContacts(selectedInner)"
      @clickForFinish="creditWarningPopup = false,numberOfCreditMessage = null,isCreditDeductionEnable = false,selectedMain = [],selectedInner = []"
      @queryToCSV="creditWarningPopup = false,numberOfCreditMessage   = null,isCreditDeductionEnable = false,exportContactType=null,addJobNamePopup=true"
    ></find-any-one-credit-warning-modal>

    <!-- credit limit warning popup (If there are no enough contact limit then this will open) -->
    <find-any-one-credit-limit-warning-modal
      :popupTitle="'Contact Credits'"
      :isPopup="creditLimitWarningPopup"
      @clickForFinish="creditLimitWarningPopup = false"
    ></find-any-one-credit-limit-warning-modal>

    <!-- Add Update tag popup -->
    <find-any-one-add-update-tag-modal
      ref="addUpdateTag"
      :isAddUpdateTagPopupActive="addUpdateTagPopup"
      @saveNewTag="saveUpdateTag"
      @closeAddUpdateTagPopup="getListOfUserDefinedTags(), closeAddUpdateTagPopup()"
      :tagDetails="userDefinedTagDetails"
    ></find-any-one-add-update-tag-modal>

    <!-- Add  tag To contactPopup -->
    <find-any-one-add-tag-to-selected-modal
      ref="addTagToSelectedContact"
      :isAddTagsPopupActive="addTagsPopup"
      :userDefinedTagsOptions="selectTagsOptions"
      @closePopupAddTagToSelected="addTagsPopup = false"
      @addTagToContacts="addTagToContacts"
      @createNewTag="addUpdateTagPopup = true"
      :requestFromModule="tagModuleRequest"
      @updateTagToContacts="updateTagsContactDetails"
      @removeTagToContacts="removeTagsFromContactConfirmation"
    ></find-any-one-add-tag-to-selected-modal>

    <!-- remove tag -->
    <find-any-one-remove-tag-modal
      :isRemoveTagPopupActive="removeTagPopup"
      @clickCloseRemoveTagPopup="
        removeTagPopup = false,
        companyDetailPopup ? (selectedInner = []) : (selectedMain = [])
      "
      @removeTagsFromContact="removeTagsFromContact"
    ></find-any-one-remove-tag-modal>

    <!-- manage tag -->
    <find-any-one-manage-tag-modal
      :isManageTagsPopupActive="manageTagsPopup"
      :userDefinedTagsList="selectTagsOptions"
      @closeManageTagPopup="manageTagsPopup = false"
      @clickOnDeleteTag="deleteUserDefinedTag"
      @createNewTag="addUpdateTagPopup = true"
      @editUserDefinedTag="editUserDefinedTag"
    ></find-any-one-manage-tag-modal>

    <!-- please select contacts -->
    <find-any-one-select-contact-add-to-saved-warning-modal
      :popupTitle="LabelConstant.popupTitleLabelSavedContacts"
      :isPopup="selecteContactWarningForAddToMySavedPopup"
      :selectContactWarningMessage="selecteContactWarningForAddToMySavedPopupMessage"
      @clickForFinish="selecteContactWarningForAddToMySavedPopup = false"
    ></find-any-one-select-contact-add-to-saved-warning-modal>

    <!-- Credit warning for add to my saved -->
    <find-any-one-credit-warning-add-to-saved-modal
      :popupTitle="'Contact Credits'"
      :isPopup="openAddToMySavedContactsCreditPopup"
      :creditWarningMessage="openAddToMySavedContactsCreditPopupMessage"
      @clickForYes="getContactLimitsForAddToMySavedContacts()"
      @clickForNo="cancelAddToMySavedContacts()"
    ></find-any-one-credit-warning-add-to-saved-modal>

    <!-- Success massage for add to my saved -->
    <find-any-one-success-message-add-to-saved-modal
      :popupTitle="'Contact Credits'"
      :isPopup="addToMySavedContactsSuccessPopup"
      @clickForFinish="addToMySavedContactsSuccessPopup = false"
    ></find-any-one-success-message-add-to-saved-modal>

    <!-- Contacts details modal -->
    <find-any-one-contact-details-modal
      :contactsDetailPopup="contactsDetailPopup"
      @clickForClose="closeContactDetailsPopup()"
      :contactDetails="contactDetails"
      @editTagsForContact="editTagsForContact()"
      moduleName="savedContact"
    ></find-any-one-contact-details-modal>

    <!-- Job name -->
    <find-any-one-data-enrichment-jobname
      ref="enrichmentJobName"
      :isaddJobNamePopup="addJobNamePopup"
      @clickOnSave="runDataEnrichmentJobQueryResultToCSV"
      @clickForClose="closeDataEnrichmentJobNamePopup"
      :jobNameValue="dataEnrichmentJobName"
      @jobNameInput="
        (newJobName) => {
          dataEnrichmentJobName = newJobName;
        }
      "
      :showJobNameErrorMessage="showJobNameErrorMessage"
      :jobNameErrorMessage="jobNameErrorMessage"
    ></find-any-one-data-enrichment-jobname>

    <!-- Job message -->
    <find-any-one-data-enrichment-export-query-message
      :isDataEnrichmentJobMessagePopup="exportJobRequestedMessage"
      :message="jobMessage"
      @clickForClose="exportJobRequestedMessage = false,jobMessage=''"
    ></find-any-one-data-enrichment-export-query-message>

    <!-- Company details modal -->
    <find-any-one-company-details-modal
      ref="searchContactsRef"
      :companyDetailPopup="companyDetailPopup"
      @clickForClose="closeCompanyDetailPopup()"
      :companyDetail="companyDetail"
      :showEntriesOptions="showEntriesOptions"
      :recordPerInnerPageValue="recordPerInnerPage"
      @recordPerInnerPageInput="
        (newRecordPerInnerPage) => {
          recordPerInnerPage = newRecordPerInnerPage;
        }
      "
      @clickForExport="getContactLimits"
      @exportType="
        (newExportType) => {
          savedExportType = newExportType;
        }
      "
      :isShowAddToMySavedContactsButton="false"
      :selectedInnerValue="selectedInner"
      @selectedInnerInput="
        (newSelectedInner) => {
          selectedInner = newSelectedInner;
        }
      "
      @contactsDetailPopupInput="
        (newContactsDetailPopup) => {
          contactsDetailPopup = newContactsDetailPopup;
          tagModuleRequest = 'update';
        }
      "
      @selectedContactIdInput="
        (newSelectedContactId) => {
          selectedContactId = newSelectedContactId;
        }
      "
      @clickForAddToMySavedContacts="addToMySavedContacts()"
      @clickForGetSavedContactDetail="getSavedContactDetail()"
      @clickForOpenContactCreditPopup="openContactCreditPopup()"
      :companyTotalContacts="companyTotalContacts"
      :companyTotalPages="companyTotalPages"
      @clickForGetCompanyDetailByPagination="getCompanyDetailByPagination"
      :jobLevelOptions="jobLevelOptions"
      :jobFunctionOptions="jobFunctionOptions"
      :jobStartDateOptions="jobStartDateOptions"
      :contactRegionOptions="contactRegionOptions"
      :addressTypeOptions="addressTypeOptions"
      :contactCountriesOptions="contactCountriesOptions"
      :contactStatesOptions="contactStatesOptions"
      :personalContactGenderOptions="personalContactGenderOptions"
      :selectedCompanyId="selectedCompanyId"
      @addTagToSelected="addTagToSeleted(), (tagModuleRequest = 'add')"
      @removeTagToSelected="removeTagSelected(), (tagModuleRequest = 'remove')"
      @manageTags="manageTagsPopup = true,tagModuleRequest = 'add',listContactSavedTags()"
    ></find-any-one-company-details-modal>

    <!-- Zapier Message -->
    <find-any-one-zapier-set-up-warning-message
      :popupTitle="zapierPopupTitle"
      :isPopup="isZapierSetupWarningPopup"
      :message="zapierSetupMessage"
      @clickForClose="isZapierSetupWarningPopup = false, zapierPopupTitle = '', zapierSetupMessage = ''"
    ></find-any-one-zapier-set-up-warning-message>
  </div>
</template>

<script>
import Vue from "vue";
import CollapseAccordion from "../../components/collapse/CollapseAccordion";
import InputTag from "vue-input-tag";
import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);
import vSelect from "vue-select";
import findAnyoneSavedContactsMixin from "../../mixins/findAnyoneSavedContactsMixin";
import findAnyoneMixin from "../../mixins/findAnyoneMixin";
import FindAnyOneSearchTipsModal from "../../components/modal/FindAnyOneSearchTipsModal.vue";
import FindAnyOneExportOptionsModal from "../../components/modal/FindAnyOneExportOptionsModal.vue";
import FindAnyOneDownloadFinal from "../../components/modal/FindAnyOneDownloadFinal.vue";
import FindAnyOneCreditWarningModal from "../../components/modal/FindAnyOneCreditWarningModal.vue";
import FindAnyOneCreditLimitWarningModal from "../../components/modal/FindAnyOneCreditLimitWarningModal.vue";
import FindAnyOneContactDetailsModal from "../../components/modal/FindAnyOneContactDetailsModal.vue";
import FindAnyOneCompanyDetailsModal from "../../components/modal/FindAnyOneCompanyDetailsModal.vue";
import FindAnyOneSelectConnection from "../../components/modal/FindAnyOneSelectConnection.vue";
import FindAnyOneAddTagToSelectedModal from "../../components/modal/FindAnyOneAddTagToSelectedModal.vue";
import FindAnyOneManageTagModal from "../../components/modal/FindAnyOneManageTagModal.vue";
import FindAnyOneAddUpdateTagModal from "../../components/modal/FindAnyOneAddUpdateTagModal.vue";
import FindAnyOneSelectContactAddToSavedWarningModal from "../../components/modal/FindAnyOneSelectContactAddToSavedWarningModal.vue";
import FindAnyOneRemoveTagModal from "../../components/modal/FIndAnyOneRemoveTagModal.vue";
import FindAnyOneCreditWarningAddToSavedModal from "../../components/modal/FindAnyOneCreditWarningAddToSavedModal.vue";
import FindAnyOneSuccessMessageAddToSavedModal from "../../components/modal/FindAnyOneSuccessMessageAddToSavedModal.vue";
import FindAnyOneZapierSetUpWarningMessage from '../../components/modal/FindAnyOneZapierSetUpWarningMessage.vue'
import FindAnyOneDataEnrichmentJobname from "../../components/modal/FindAnyOneDataEnrichmentJobname.vue";
import FindAnyOneDataEnrichmentExportQueryMessage from "../../components/modal/FindAnyOneDataEnrichmentExportQueryMessage.vue";
import { XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx";
import { BPagination } from "bootstrap-vue";
import VueJwtDecode from "vue-jwt-decode";
import DropdownMenu from "v-dropdown-menu";
import "v-dropdown-menu/dist/v-dropdown-menu.css";

export default {
  mixins: [findAnyoneSavedContactsMixin, findAnyoneMixin],
  components: {
    CollapseAccordion,
    InputTag,
    "v-select": vSelect,
    FindAnyOneSearchTipsModal,
    FindAnyOneExportOptionsModal,
    FindAnyOneDownloadFinal,
    FindAnyOneCreditWarningModal,
    FindAnyOneCreditLimitWarningModal,
    FindAnyOneContactDetailsModal,
    FindAnyOneCompanyDetailsModal,
    FindAnyOneSelectConnection,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    BPagination,
    VueJwtDecode,
    FindAnyOneAddTagToSelectedModal,
    FindAnyOneManageTagModal,
    FindAnyOneAddUpdateTagModal,
    FindAnyOneSelectContactAddToSavedWarningModal,
    FindAnyOneRemoveTagModal,
    FindAnyOneCreditWarningAddToSavedModal,
    FindAnyOneSuccessMessageAddToSavedModal,
    FindAnyOneDataEnrichmentJobname,
    FindAnyOneDataEnrichmentExportQueryMessage,
    FindAnyOneZapierSetUpWarningMessage,
    DropdownMenu,
  },
  data: () => ({
    //Set to show and hide the export tag menu's
    appRunningOnDev: process.env.VUE_APP_RUNNING_ON_DEV ? process.env.VUE_APP_RUNNING_ON_DEV : "",
    input2: "",
    initialRole: "",
    currentPage: 1,
    connectionPopup: false,
    // addNewtagPopup: false,
    // addtagsPopup: false,
    //removeTagPopup:false,
    //manageTagsPopup:false,
    pushModule: null,
    enableZapierIntegration: false,
  }),
  created() {
    this.decodeJWT();
    let uid = this.$route.params.id
    let VVtoken = localStorage.getItem("VVtoken");
    let token = JSON.parse(VVtoken);
    this.enableZapierIntegration = token[uid].enableZapierIntegration
  },
  methods: {
    decodeJWT() {
      let uid = this.$route.params.id;
      let jwtDecode = VueJwtDecode.decode(
        this.$store.state.authTokenVV[uid].token
      );
      this.initialRole = jwtDecode.initialRole;
    },
  },
};
</script>
